import { render } from "./LineLogin.vue?vue&type=template&id=37d08a52"
import script from "./LineLogin.vue?vue&type=script&lang=js"
export * from "./LineLogin.vue?vue&type=script&lang=js"
script.render = render

export default script